import { render } from "./sosVue.vue?vue&type=template&id=4798d46d"
import script from "./sosVue.vue?vue&type=script&lang=js"
export * from "./sosVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__